import React, { useCallback } from "react";
import {
  Divider,
  Layout,
  Popover,
  Radio,
  RadioChangeEvent,
  Space,
  Tag,
} from "antd";
import { AddGroupButton } from "@/views/DashboardView/components/add-group-button";
import { useDashboardGroups, useDashboardPanelContext } from "@data-root/react";

const { Content } = Layout;

export const GroupButton = () => {
  const { groupId, group, setGroup } = useDashboardPanelContext();
  const groups = useDashboardGroups();

  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      setGroup(e.target.value);
    },
    [setGroup]
  );

  return (
    <Popover
      content={
        <Layout>
          <Content>
            <AddGroupButton />

            <Divider />

            <Radio.Group value={groupId} onChange={onChange}>
              <Space direction="vertical">
                {groups.map((group) => (
                  <Radio key={group.id} value={group.id}>
                    {group.name}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Content>
        </Layout>
      }
    >
      {group ? (
        <Tag color="blue">{group.name}</Tag>
      ) : (
        <Tag color="gray">No group</Tag>
      )}
    </Popover>
  );
};
